<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [columns]="columns"
      [title]="'admin.sideNav.approvals' | translate"
      [loading]="loading()"
      [rowModelType]="rowModelType"
      [datasource]="datasource"
      [cacheBlockSize]="cacheBlockSize"
      [maxBlocksInCache]="maxBlocksInCache"
      [rowHeight]="rowHeight"
      [showSearch]="true"
      (searchChange)="onSearch($event)"
      detailsBaseRoute="/admin/approvals"
    ></app-grid-table>
  </div>
</div>
